import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { AppMenuitemComponent } from './app.menuitem.component';
import { CommonModule } from '@angular/common';
import { AuthService } from '../core/auth/auth.service';



@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [AppMenuitemComponent, CommonModule],
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];
    isAdmin:boolean = false;

    constructor(private authService:AuthService) {
        this.carregar();
    }

    async carregar() {
        this.isAdmin = await this.authService.isAdmin();
    }

    ngOnInit() {
        this.model = [
            {
                label: 'Home',
                items: [
                    { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
                ]
            },
            {
                label: 'Paineis',
                icon: 'pi pi-fw pi-briefcase',
                items: [
                    {
                        label: 'Valores Recebidos',
                        icon: 'pi pi-fw pi-list',
                        items: [
                            { label: 'Sintético', icon: 'pi pi-fw pi-chart-line', routerLink: ['/valoresrecebidos'] },
                            { label: 'Analitico',icon: 'pi pi-fw pi-chart-pie',routerLink: ['/valoresrecebidosanalitico'] },
                        ]
                    },
                    {
                        label: 'Inadimplentes',
                        icon: 'pi pi-fw pi-list',
                        items: [
                            { label: 'Sintético', icon: 'pi pi-fw pi-chart-line', routerLink: ['/inadimplentes'] },
                            { label: 'Analitico',icon: 'pi pi-fw pi-chart-pie',routerLink: ['/inadimplentesanalitico'] },
                        ]
                    },
                    {
                        label: 'Dívida Ativa',
                        icon: 'pi pi-fw pi-list',
                        items: [
                            { label: 'Sintético', icon: 'pi pi-fw pi-chart-line', routerLink: ['/dividaativa'] },
                            { label: 'Analitico',icon: 'pi pi-fw pi-chart-pie',routerLink: ['/dividaativaanalitico'] },
                        ]
                    },
                ]
            },
            {
                label: 'Relatórios',
                icon: 'pi pi-fw pi-file',
                items: [
                    { label: 'Remissões', icon: 'pi pi-fw pi-file-excel', routerLink: ['/remissoes'] },
                    { label: 'Faixa de Capital Social', icon: 'pi pi-fw pi-file-excel', routerLink: ['/faixacapitalsocial'] },
                    { label: 'Extrato Mensal', icon: 'pi pi-fw pi-file-excel', routerLink: ['/extrato-mensal'] }
                ]
            },
            {
                label: 'Consultas', // Nova seção
                icon: 'pi pi-fw pi-search',
                items: [
                    { label: 'Busca Médico', icon: 'pi pi-fw pi pi-search', routerLink: ['/buscamedico'] }
                ]
            },
            {
                label: 'Admin',
                icon: 'pi pi-fw pi-briefcase',
                visible:  this.isAdmin,
                items: [
                    { label: 'Pendências', icon: 'pi pi-fw pi-chart-line', routerLink: ['/pendencias'] },
                ]
            }
        ];

    }

}
